import { render, staticRenderFns } from "./SplashView.vue?vue&type=template&id=1d7c107e&"
import script from "./SplashView.vue?vue&type=script&lang=js&"
export * from "./SplashView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports